import { render } from "./flow-type-label.vue?vue&type=template&id=005584a1&scoped=true&lang=pug"
import script from "./flow-type-label.vue?vue&type=script&lang=js"
export * from "./flow-type-label.vue?vue&type=script&lang=js"

import "./flow-type-label.vue?vue&type=style&index=0&id=005584a1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-005584a1"]])

export default __exports__